import p from '../passes/passes.module.css';
import s from './more.module.css';

const RELEASES = [
  {
    version: '1.0',
    items: [
      'Вход по номеру из Telegram — без пароля и SMS',
      'Заказ пропуска за два касания, частые гости',
      'Ссылка для гостя: он сам впишет номер',
      'Пропуска с QR и PIN, история проездов',
      'Обращения и переписка с УК, доверенности',
    ],
  },
];

export function WhatsNewScreen() {
  return (
    <main className={p.page}>
      <h1 className={p.title}>Что нового</h1>
      {RELEASES.map((r) => (
        <section key={r.version}>
          <h2 className={s.rowName}>Версия {r.version}</h2>
          <ul>
            {r.items.map((i) => (
              <li key={i} className={s.text}>
                {i}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </main>
  );
}
